import axios from "axios";

export const PROYECT = "/crm";
export const _PROJECT = "GN4"

const axiosInstance = axios.create({
  // baseURL:'',
  baseURL: process.env.REACT_APP_URL,
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let message = "";
    if (error?.response?.status === 404) {
      message =  error?.response?.data?.message?.error || "Error al enviar la petición.";
    } else if(error?.response?.data && error?.response?.data?.message && error?.response?.data?.message?.error) {
      const { data } = error?.response;
      message = data?.message?.error
    } else {
      message = "Existe un problema con el servicio, intente de nuevo mas tarde, si el problema persiste contacte a soporte.";
    }

    if (error?.response?.status === 401) {
      console.error("RESPONSE 401");
      localStorage.removeItem("persist:root");
      window.location.href = "/login";
      return Promise.reject(message);
    }
    console.error("Axios Response Error: ", error?.response, message);
    return Promise.reject(message);
  }
);

export const api_get = (url, nHeaders = {}) => {
  const { responseType, ...restHeaders } = nHeaders;

  const config = {
    headers: {
      Authorization: getToken(),
      ...restHeaders
    },
    ...(responseType && { responseType })
  };

  return new Promise((res, rej) => {
    axiosInstance
      .get(url, config)
      .then(({ data }) => res(data))
      .catch((err) => {
         rej(err)
      });
  });
};


export const api_post = (url, body, headers = {}) => {
  const config = {
    headers: {
      Authorization: getToken(),
      ...headers
    }
  };
  
  return new Promise((res, rej) => {
    axiosInstance
      .post(url, body, config)
      .then(({ data }) => {
        res(data);
      })
      .catch((err) => {
        return rej(err);
      });
  });
};

export const api_put = (url, body, headers = {}) => {
  headers = { headers:{Authorization: getToken() }}
  return new Promise((res, rej) => {
    axiosInstance
      .put(url, body, headers)
      .then(({ data }) => {
        res(data);
      })
      .catch((err) => {
        return rej(err);
      });
  });
};

export const api_delete = (url, body, headers = {}) => {
  headers = { headers:{Authorization: getToken() }}
  return new Promise((res, rej) => {
    axiosInstance
      .delete(url, { ...headers, data: body })
      .then(({ data }) => {
        res(data);
      })
      .catch((err) => {
        return rej(err);
      });
  });
};

/**
 * Download file from URI
 * @param {string} url 
 * @returns File buffer
 */
export const api_get_file = async (url) => {
  const response = await axios.get(url, { responseType: 'arraybuffer' });

  const fileData = new Uint8Array(response.data)

  return fileData;
}

/**
 * GET request returning full response with blob data
 * @param {string} url
 * @returns {Promise<AxiosResponse>}
 */
export const api_get_blob = (url) => {
  return axiosInstance.get(url, {
    headers: { Authorization: getToken() },
    responseType: "blob",
  });
};

/**
 * PUT request with multipart/form-data
 * @param {string} url
 * @param {FormData} formData
 * @returns {Promise<any>} Response data
 */
export const api_put_multipart = async (url, formData) => {
  const { data } = await axiosInstance.put(url, formData, {
    headers: { Authorization: getToken() },
  });
  return data;
};

const getToken = () => {
  const crmUser = localStorage.getItem('crm-user');
  return crmUser;
}

export const api_patch = (url, body, headers = {}) => {
  headers = { headers:{Authorization: getToken() }}
  return new Promise((res, rej) => {
    axiosInstance
      .patch(url, body, headers)
      .then(({ data }) => {
        res(data);
      })
      .catch((err) => {
        return rej(err);
      });
  });
};